import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Alert, Button, Flex, Space, Table, Tag } from 'antd';
import _ from 'lodash-es';
import { useEffect, useState } from "react";
import intl from 'react-intl-universal';

import Evisit from "../../../libs/Evisit";

const columns = () => {
    var data = [
        {
            title: intl.get('description').d('Description'),
            dataIndex: 'description',
            render: (text, record) => {
                if (_.get(record, 'group')) {
                    return (
                        <Space>
                            {text}
                            <Tag color="error">
                                {intl.get('group').d('Group')}
                            </Tag>
                        </Space>
                    )
                }
                return text
            }
        }
    ];
    if (!Evisit.c('Account.consultation.duration.is_hidden', false)) {
        data.push({
            title: intl.get('duration').d('Duration'),
            dataIndex: 'duration_text',
        });
    }
    if (Evisit.c('Account.payment.enabled') && !Evisit.c('Account.consultation.amount.is_hidden')) {
        data.push({
            title: intl.get('fee').d('Fee'),
            dataIndex: 'amount_text',
        });
    }
    return data;
}

const formatData = (data, room) => {
    const result = {
        key: data.id,
        duration_text: intl.get("v_mins", {val: data.duration}).d("{val} mins")
    };
    if (Evisit.c('Account.payment.enabled') && !Evisit.c('Account.consultation.amount.is_hidden')) {
        result.amount_text = (Number(data.amount) > 0) 
            ? _.get(room, "payment.paymentCurrency", "USD") + ' ' + Number(data.amount)
            : Evisit.c('Account.consultation.amount.free_text', '');
    }

    return result;
}

const consultationData = (room) => {
    return _.filter(_.get(room, 'payment.consultations', []), (consultation) => {
        return consultation.visible_to_patient !== false; 
    }).map((data) => ({
        ...data,
        ...formatData(data, room)
    }));
}

const Consultation = ({currentComponent, onNext, onPrevious, data, isMobileWebview}) => {
    const [error, setError] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const room = _.get(data, 'room.value', {});

    const onSubmit = async () => {
        setLoading(true);
        const submission = _.find(consultationData(room), {id: selectedRowKeys[0]});
        setError(null);
        if (!submission) {
            setLoading(false);
            setError(intl.get("err_no_consult_type").d("Please select a consultation type"));
        } else {
            onNext({
                "consultation": _.omit(submission, ['key', 'amount_text', 'duration_text']),
                "paymentCurrency": room.currency || _.get(room, "payment.paymentCurrency", "USD"),
                "room_code": room.code
            });
        }
    }
    const onSelectChange = newSelectedRowKeys => {
        if (selectedRowKeys.length === 1 && selectedRowKeys === newSelectedRowKeys) {
            return;
        }
        setSelectedRowKeys(newSelectedRowKeys); 
    }
    const rowSelection = {
        type: "radio",
        selectedRowKeys,
        onChange: onSelectChange
    }
    
    useEffect(() => {
        if (currentComponent.value) {
            setSelectedRowKeys([currentComponent.value.consultation.id]);
        }
    }, [currentComponent.value]);

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <h4>{intl.get('visit_option').d('Visit Option')}</h4>
            { error && <Alert message={ error } type="error" /> }
            <div style={{
                overflow: "auto",
                width: "100%"
            }}>
                <Table
                    columns={columns()}
                    dataSource={consultationData(room)}
                    rowSelection={rowSelection}
                    pagination={false}
                />
            </div>
            
            <Flex justify={isMobileWebview ? "center" : "space-between"}>
                { (onPrevious != null && !isMobileWebview) ?
                    <Button onClick={ onPrevious }>
                        <LeftOutlined style={{verticalAlign:"middle"}} />
                        {intl.get("back").d("Back")}
                    </Button> : <div></div>
                }
                <Button
                    type="primary"
                    onClick={() => onSubmit()}
                    loading={loading}
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                >
                    {intl.get("continue").d("Continue")}
                    <RightOutlined style={{verticalAlign:"middle"}} />
                </Button>
            </Flex>
        </Space>
    );
}

export default Consultation;